import { epicRequest } from 'app'

export const USER_REGISTRATIONS_FETCH = 'USER_REGISTRATIONS_FETCH'
export const USER_REGISTRATIONS_FETCH_ERROR = 'USER_REGISTRATIONS_FETCH_ERROR'
export const USER_REGISTRATIONS_FETCH_FULFILLED = 'USER_REGISTRATIONS_FETCH_FULFILLED'
export const USER_REGISTRATIONS_FETCH_CANCELED = 'USER_REGISTRATIONS_FETCH_CANCELED'

export const USER_POSTS_VS_INTERACTIONS_FETCH = 'USER_POSTS_VS_INTERACTIONS_FETCH'
export const USER_POSTS_VS_INTERACTIONS_FETCH_ERROR = 'USER_POSTS_VS_INTERACTIONS_FETCH_ERROR'
export const USER_POSTS_VS_INTERACTIONS_FETCH_FULFILLED = 'USER_POSTS_VS_INTERACTIONS_FETCH_FULFILLED'
export const USER_POSTS_VS_INTERACTIONS_FETCH_CANCELED = 'USER_POSTS_VS_INTERACTIONS_FETCH_CANCELED'

export const USER_REGISTRATIONS_PER_DEVICE_FETCH = 'USER_REGISTRATIONS_PER_DEVICE_FETCH'
export const USER_REGISTRATIONS_PER_DEVICE_FETCH_ERROR = 'USER_REGISTRATIONS_PER_DEVICE_FETCH_ERROR'
export const USER_REGISTRATIONS_PER_DEVICE_FETCH_FULFILLED = 'USER_REGISTRATIONS_PER_DEVICE_FETCH_FULFILLED'
export const USER_REGISTRATIONS_PER_DEVICE_FETCH_CANCELED = 'USER_REGISTRATIONS_PER_DEVICE_FETCH_CANCELED'

export const USER_REGISTRATIONS_PER_INSTITUTION_FETCH = 'USER_REGISTRATIONS_PER_INSTITUTION_FETCH'
export const USER_REGISTRATIONS_PER_INSTITUTION_FETCH_ERROR = 'USER_REGISTRATIONS_PER_INSTITUTION_FETCH_ERROR'
export const USER_REGISTRATIONS_PER_INSTITUTION_FETCH_FULFILLED = 'USER_REGISTRATIONS_PER_INSTITUTION_FETCH_FULFILLED'
export const USER_REGISTRATIONS_PER_INSTITUTION_FETCH_CANCELED = 'USER_REGISTRATIONS_PER_INSTITUTION_FETCH_CANCELED'

export const TODAY_MATCHES_FETCH = 'TODAY_MATCHES_FETCH'
export const TODAY_MATCHES_FETCH_ERROR = 'TODAY_MATCHES_FETCH_ERROR'
export const TODAY_MATCHES_FETCH_FULFILLED = 'TODAY_MATCHES_FETCH_FULFILLED'
export const TODAY_MATCHES_FETCH_CANCELED = 'TODAY_MATCHES_FETCH_CANCELED'

export const TODAY_USERS_REGISTRATIONS_FETCH = 'TODAY_USERS_REGISTRATIONS_FETCH'
export const TODAY_USERS_REGISTRATIONS_FETCH_ERROR = 'TODAY_USERS_REGISTRATIONS_FETCH_ERROR'
export const TODAY_USERS_REGISTRATIONS_FETCH_FULFILLED = 'TODAY_USERS_REGISTRATIONS_FETCH_FULFILLED'
export const TODAY_USERS_REGISTRATIONS_FETCH_CANCELED = 'TODAY_USERS_REGISTRATIONS_FETCH_CANCELED'

export const STATS_INITIAL_STATE = {
  postsVsInteractions: {},
  registrations: {},
  registrationsPerDevice: {},
  registrationsPerInstitution: {},
}

export const userPostsVsInteractionsFetch = (from, to, interval) => ({
  payload: {
    from,
    interval,
    to,
  },
  type: USER_POSTS_VS_INTERACTIONS_FETCH,
})

export const userPostsVsInteractionsFetchFulfilled = (payload) => ({
  payload,
  type: USER_POSTS_VS_INTERACTIONS_FETCH_FULFILLED,
})

export const userPostsVsInteractionsFetchError = (payload) => ({
  payload,
  type: USER_POSTS_VS_INTERACTIONS_FETCH_ERROR,
})

export const userPostsVsInteractionsFetchCanceled = () => ({
  payload: null,
  type: USER_POSTS_VS_INTERACTIONS_FETCH_CANCELED,
})

export const userPostsVsInteractionsFetchEpic = epicRequest({
  actionType: USER_POSTS_VS_INTERACTIONS_FETCH,
  errorAction: userPostsVsInteractionsFetchError,
  fulfilledAction: userPostsVsInteractionsFetchFulfilled,
  request: ({ payload }) =>
    `stats/postsVsInteractions?from=${payload.from}&to=${payload.to}&interval=${payload.interval}`,
  untilTypes: USER_POSTS_VS_INTERACTIONS_FETCH_CANCELED,
})

export const usersRegistrationsFetch = (from, to, interval) => ({
  payload: {
    from,
    interval,
    to,
  },
  type: USER_REGISTRATIONS_FETCH,
})

export const usersRegistrationsFetchFulfilled = (payload) => ({
  payload,
  type: USER_REGISTRATIONS_FETCH_FULFILLED,
})

export const usersRegistrationsFetchError = (payload) => ({
  payload,
  type: USER_REGISTRATIONS_FETCH_ERROR,
})

export const usersRegistrationsFetchCanceled = () => ({
  payload: null,
  type: USER_REGISTRATIONS_FETCH_CANCELED,
})

export const usersRegistrationsFetchEpic = epicRequest({
  actionType: USER_REGISTRATIONS_FETCH,
  errorAction: usersRegistrationsFetchError,
  fulfilledAction: usersRegistrationsFetchFulfilled,
  request: ({ payload }) =>
    `stats/registrationVsVerification?from=${payload.from}&to=${payload.to}&interval=${payload.interval}`,
  untilTypes: USER_REGISTRATIONS_FETCH_CANCELED,
})

export const usersRegistrationsPerDeviceFetch = (from, to, interval) => ({
  payload: {
    from,
    interval,
    to,
  },
  type: USER_REGISTRATIONS_PER_DEVICE_FETCH,
})

export const usersRegistrationsPerDeviceFetchFulfilled = (payload) => ({
  payload,
  type: USER_REGISTRATIONS_PER_DEVICE_FETCH_FULFILLED,
})

export const usersRegistrationsPerDeviceFetchError = (payload) => ({
  payload,
  type: USER_REGISTRATIONS_PER_DEVICE_FETCH_ERROR,
})

export const usersRegistrationsPerDeviceFetchCanceled = () => ({
  payload: null,
  type: USER_REGISTRATIONS_PER_DEVICE_FETCH_CANCELED,
})

export const usersRegistrationsPerDeviceFetchEpic = epicRequest({
  actionType: USER_REGISTRATIONS_PER_DEVICE_FETCH,
  errorAction: usersRegistrationsPerDeviceFetchError,
  fulfilledAction: usersRegistrationsPerDeviceFetchFulfilled,
  request: ({ payload }) =>
    `stats/registrationPerDevice?from=${payload.from}&to=${payload.to}&interval=${payload.interval}`,
  untilTypes: USER_REGISTRATIONS_PER_DEVICE_FETCH_CANCELED,
})

export const usersRegistrationsPerInstitutionFetch = (from, to, interval) => ({
  payload: {
    from,
    interval,
    to,
  },
  type: USER_REGISTRATIONS_PER_INSTITUTION_FETCH,
})

export const usersRegistrationsPerInstitutionFetchFulfilled = (payload) => ({
  payload,
  type: USER_REGISTRATIONS_PER_INSTITUTION_FETCH_FULFILLED,
})

export const usersRegistrationsPerInstitutionFetchError = (payload) => ({
  payload,
  type: USER_REGISTRATIONS_PER_INSTITUTION_FETCH_ERROR,
})

export const usersRegistrationsPerInstitutionFetchCanceled = () => ({
  payload: null,
  type: USER_REGISTRATIONS_PER_INSTITUTION_FETCH_CANCELED,
})

export const usersRegistrationsPerInstitutionFetchEpic = epicRequest({
  actionType: USER_REGISTRATIONS_PER_INSTITUTION_FETCH,
  errorAction: usersRegistrationsPerInstitutionFetchError,
  fulfilledAction: usersRegistrationsPerInstitutionFetchFulfilled,
  request: ({ payload }) =>
    `stats/registrationPerInstitution?from=${payload.from}&to=${payload.to}&interval=${payload.interval}`,
  untilTypes: USER_REGISTRATIONS_PER_INSTITUTION_FETCH_CANCELED,
})

export const todayMatchesFetch = (from, to) => ({
  payload: {
    from,
    to,
  },
  type: TODAY_MATCHES_FETCH,
})

export const todayMatchesFetchFulfilled = (payload) => ({
  payload,
  type: TODAY_MATCHES_FETCH_FULFILLED,
})

export const todayMatchesFetchError = (payload) => ({
  payload,
  type: TODAY_MATCHES_FETCH_ERROR,
})

export const todayMatchesFetchCanceled = () => ({
  payload: null,
  type: TODAY_MATCHES_FETCH_CANCELED,
})

export const todayMatchesFetchEpic = epicRequest({
  actionType: TODAY_MATCHES_FETCH,
  errorAction: todayMatchesFetchError,
  fulfilledAction: todayMatchesFetchFulfilled,
  request: ({ payload }) => `stats/scheduledMatches?from=${payload.from}&to=${payload.to}`,
  untilTypes: TODAY_MATCHES_FETCH_CANCELED,
})

export const todayUsersRegistrationsFetch = (from, to) => ({
  payload: {
    from,
    to,
  },
  type: TODAY_USERS_REGISTRATIONS_FETCH,
})

export const todayUsersRegistrationsFetchFulfilled = (payload) => ({
  payload,
  type: TODAY_USERS_REGISTRATIONS_FETCH_FULFILLED,
})

export const todayUsersRegistrationsFetchError = (payload) => ({
  payload,
  type: TODAY_USERS_REGISTRATIONS_FETCH_ERROR,
})

export const todayUsersRegistrationsFetchCanceled = () => ({
  payload: null,
  type: TODAY_USERS_REGISTRATIONS_FETCH_CANCELED,
})

export const todayUsersRegistrationsFetchEpic = epicRequest({
  actionType: TODAY_USERS_REGISTRATIONS_FETCH,
  errorAction: todayUsersRegistrationsFetchError,
  fulfilledAction: todayUsersRegistrationsFetchFulfilled,
  request: ({ payload }) => `stats/usersRegistrations?from=${payload.from}&to=${payload.to}`,
  untilTypes: TODAY_USERS_REGISTRATIONS_FETCH_CANCELED,
})
